export default __webpack_public_path__ + "fonts/plan-team.svg";